import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const tabClass = ({ isActive }) =>
  `px-4 py-3 -mb-px text-[15px] font-semibold transition-colors whitespace-nowrap border-b-2 ${
    isActive
      ? 'text-gray-900 border-gray-900'
      : 'text-gray-500 border-transparent hover:text-gray-900'
  }`;

export default function ConsultManagementLayout() {
  return (
    <div className="flex flex-col min-h-full">
      <div className="border-b border-gray-200 mb-4">
        <div className="flex gap-1" role="tablist" aria-label="상담 관리">
          <NavLink to="/quotes" end className={tabClass} role="tab">
            상담관리
          </NavLink>
          <NavLink to="/quotes/open" className={tabClass} role="tab">
            공개 견적 요청(개발중)
          </NavLink>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
